<template>
  <div class="CameraControl">
    <div class="title">摄像头</div>
    <div v-for="(item, key) in camerDdata" :key="key">
      <Vue3DraggableResizable
        :w="300"
        :h="200"
        v-model:x="item.x"
        v-model:y="item.y"
        :draggable="true"
        :resizable="true"
        v-show="item.checkbox"
      >
        <div class="radar-wrap">
          <div class="radar-wrap-text">
            {{ key }}
            <span class="close" @click="item.checkbox = false">&times;</span>
          </div>
          <img :src="item.url" alt="" />
        </div>
      </Vue3DraggableResizable>
    </div>

    <div class="btns">
      <div
        class="card"
        v-for="item in data"
        :key="item.type"
        @click.capture="onClick(item.type)"
        :class="
          !camerDdata[item.type].url
            ? 'disabled'
            : camerDdata[item.type].checkbox
            ? 'active'
            : ''
        "
      >
        <div class="icon" :class="item.iconName"></div>
        <div>
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onUnmounted, provide } from 'vue'
import { useStore } from '@/store/index'

provide('identity', 'identity')
const data = [
  {
    type: 'traffic_left_image',
    iconName: 'top-left',
    text: '左前'
  },
  {
    type: 'camera360_front_image',
    iconName: 'top',
    text: '前'
  },
  {
    type: 'traffic_front_image',
    iconName: 'top-right',
    text: '右前'
  },
  {
    type: 'camera360_left_image',
    iconName: 'left',
    text: '左'
  },
  {
    type: 'camera360_rear_image',
    iconName: 'bottom',
    text: '后'
  },
  {
    type: 'camera360_right_image',
    iconName: 'right',
    text: '右'
  }
]

const camerDdata = reactive<any>({})

const reset = () => {
  data.map((v, i) => {
    let x, y
    if (i < 3) {
      x = i * 300
      y = 0
    } else {
      x = (i - 3) * 300
      y = 202
    }
    camerDdata[v.type] = {
      url: '',
      x,
      y,
      checkbox: false
    }
  })
}
reset()

const store = useStore()
const imsBaseUrl = 'data:image/jpeg;base64,'
watch(
  computed(() => store.state.wsModule.data),
  (e) => {
    ;(e.sensorData?.rawDataList || []).forEach((v: any) => {
      if (v.cameraData.image.data) {
        camerDdata[v.cameraData.cameraName].url = imsBaseUrl + v.cameraData.image.data
      }
    })
  }
)
watch(
  computed(() => store.state.wsModule.listIndex),
  (e) => {
    reset()
  }
)

const onClick = (type: string) => {
  camerDdata[type].checkbox = !camerDdata[type].checkbox
}
</script>
<style lang="less" scoped>
.top-left {
  background: no-repeat center / 100%;
}
.top-right {
  background: no-repeat center / 100%;
  transform: scaleX(-1);
}
.top-left,
.top-right {
  background-image: url(./images/left.png);
}
.active {
  color: var(--theme);
}
.top {
  background: no-repeat center / 100%;
  transform: rotate(180deg);
}
.left {
  background: no-repeat center / 100%;
  transform: rotate(90deg);
}
.right {
  background: no-repeat center / 100%;
  transform: rotate(-90deg);
}
.bottom {
  background: no-repeat center / 100%;
}
.top,
.left,
.right,
.bottom {
  background-image: url(./images/direction-active.png);
  background-image: url(./images/direction.png);
}
.CameraControl {
  color: #fff;
  padding-top: 10px;
  .title {
    font-size: 14px;
    text-align: center;
    margin-bottom: 5px;
    background: url(./images/direction-active.png), url(./images/left-active.png);
    background-size: 0;
    // font-weight: bold;
  }
}
.icon {
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
}
.btns {
  display: flex;
  width: 190px;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 0 5px;
}
.card {
  width: 55px;
  cursor: pointer;
  // margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 12px;

  &.active,
  &:hover {
    color: var(--theme);
    .top,
    .left,
    .right,
    .bottom {
      background-image: url(./images/direction-active.png);
    }
    .top-left,
    .top-right {
      background-image: url(./images/left-active.png);
    }
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
.radar-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  user-select: none;
  &-text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: var(--bg);
    text-align: center;
    font-size: 12px;
    line-height: 16px;
  }
  img {
    background: #fff;
    width: 100%;
    height: 100%;
  }
}

.close {
  float: right;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
}

:deep(.vdr-container) {
  position: fixed;
}
</style>
